/* @flow */

export const Roles = {
  LOGIN: -1,
  USER: 1,
  MANAGER: 2,
  PURCHASER: 3,
  VIEW_ONLY: 4,
  ACCOUNT_ADMIN: 5,
  ACCOUNT_MANAGER: 6,
  ASSET_MANAGER: 7,
  BUSINESS_VIEW_ONLY: 8,
  SYSTEM_ADMIN: 9,
  SYSTEM_ADMIN_REGIONAL: 10,
};

export type RoleId = number;
export type RoleList = number[];

export const RoleMap = {
  [Roles.LOGIN]: 'Login',
  [Roles.USER]: 'User',
  [Roles.MANAGER]: 'Manager',
  [Roles.PURCHASER]: 'Purchaser',
  [Roles.VIEW_ONLY]: 'Customer View Only',
  [Roles.ACCOUNT_ADMIN]: 'Account Admin',
  [Roles.ACCOUNT_MANAGER]: 'Account Manager',
  [Roles.ASSET_MANAGER]: 'Asset Manager',
  [Roles.BUSINESS_VIEW_ONLY]: 'Business View Only',
  [Roles.SYSTEM_ADMIN]: 'System Admin',
  [Roles.SYSTEM_ADMIN_REGIONAL]: 'System Admin Regional',
};

export const ServerRoleNameMap = Object.entries(RoleMap).reduce(
  (result, [id, name]) => ({ ...result, [name]: id }),
  {}
);

// Export from BE
// "id","name","guard_name","created_at","updated_at"
// 1,"User","api","2019-08-08 11:13:13","2021-01-20 17:24:35"
// 2,"Manager","api","2019-08-08 11:13:24","2021-01-20 17:24:35"
// 3,"Purchaser","api","2019-08-08 11:13:41","2021-01-20 17:24:35"
// 4,"Customer View Only","api","2019-08-08 11:13:46","2021-01-20 17:24:35"
// 5,"Account Admin","api","2019-08-08 11:13:49","2021-01-20 17:24:35"
// 6,"Account Manager","api","2019-08-08 11:14:41","2021-01-20 17:24:35"
// 7,"Asset Manager","api","2019-08-08 11:14:49","2021-01-20 17:24:35"
// 8,"Business View Only","api","2019-08-08 11:15:00","2021-01-20 17:24:35"
// 9,"System Admin","api","2019-08-08 11:15:03","2021-01-20 17:24:35"
// 10,"System Admin Regional","api","2020-10-08 09:11:29","2021-01-20 17:24:35"
